export default __webpack_public_path__ + "static/media/learose4-480w.99b3af5e.webp";